import React from 'react';
import { ErrorBoundary } from 'react-error-boundary';
import { TESTCASEARGUMENTS } from '../../../../constants/applicationConstants';
import {
  DataTableHoc,
  Loader,
  ErrorFallback,
  deleteFilter,
  applyFilter,
  saveFilters,
} from 'smart-react';
import { GridColumnsList } from '../Components/Filter/FilterElements';
import DataColumns from '../Components/DataColumns/DataColumns';
import {
  ROW_LAYOUTS,
  PAGE_SIZE,
} from '../../../../constants/applicationConstants';
const BaseArgumentDataTable = React.lazy(
  () => import('../Components/DataTable/DataTable'),
);
const ArgumentDataTable = DataTableHoc(BaseArgumentDataTable);

/**
 * TESTCASEARGUMENTS main screen
 * @type {React.FC<Props>}
 * @returns {React.ReactElement} The TESTCASEARGUMENTS component.
 */
const TestCaseArguments = ({ test }) => {
  const [userData, setUserData] = React.useState([]);
  const dataColumnsArray = DataColumns({});
  // used to check API is ready to call
  const [isReady, setIsReady] = React.useState(false);

  return (
    <ErrorBoundary
      FallbackComponent={ErrorFallback}
      onReset={() => {
        // reset the state of your app so the error doesn't happen again
      }}
    >
      <div className="container mx-auto k-px-4">
        <React.Suspense fallback={<Loader />}>
          <ArgumentDataTable
            test={test}
            deleteFilter={deleteFilter}
            applyFilter={applyFilter}
            saveFilters={saveFilters}
            moduleName={TESTCASEARGUMENTS}
            dataColumns={dataColumnsArray}
            gridColumnsList={GridColumnsList}
            dataTableName={TESTCASEARGUMENTS}
            setIsReady={setIsReady}
            isReady={isReady}
            rowLayoutConfigName={`${TESTCASEARGUMENTS}.DataGrid.RowLayout`}
            pageLengthConfigName={`${TESTCASEARGUMENTS}.DataGrid.ItemsPerPage`}
            dataSet={userData}
            setDataSet={setUserData}
            initialSort={{
              field: 'id',
              dir: 'desc',
            }}
            isCardonMobileView={false}
            total={process.env.DefaultLimit}
            defaultRowLayout={process.env.RowLayout}
            rowLayouts={ROW_LAYOUTS}
            pageSizes={PAGE_SIZE}
          />
        </React.Suspense>
      </div>
    </ErrorBoundary>
  );
};
export default TestCaseArguments;
